import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { DimentionTypes } from "@/components/dimention-field/DimentionField";
import { Spacing } from "./SpacingSettings";

const PROPS: (keyof Spacing)[] = [
  "marginBottom",
  "marginLeft",
  "marginRight",
  "marginTop",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
];

const useNormalizeSpacing = (props: Spacing) => {
  const responsive = useResponsiveValues();

  const spacing = useMemo(() => {
    const draft: Spacing = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);

        draft[prop] = value + DimentionTypes.PIXELS;
      }
    });

    return draft;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, responsive]);

  return spacing;
};

export default useNormalizeSpacing;
